<template>
    <div>
        <van-popup class="noticeDetailPop" v-model="showPop" closeable close-icon="close">
            <div class="noticeDetailPop-content">
                <div class="noticeDetailPop-title">平台公告</div>
                <div class="noticeDetailPop-name">{{info.name}}</div>
                <div class="noticeDetailPop-content">{{info.text||info.content}}</div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    data() {
        return {
            info: {},
            showPop: false
        };
    },
    methods: {
        show(info){
            this.info=info
            this.showPop=true
        },
    },
    created() {
        this.getxuanfeidata();
    },
};
</script>

<style scoped lang="less">
.noticeDetailPop{
    /deep/.van-popup__close-icon{
        font-size: 32px !important;
        color: #fff !important;
    }
}
.noticeDetailPop-content{
    width: 600px;
    .noticeDetailPop-title{
        height: 80px;
        line-height: 80px;
        background-color: #ff4d67;
        text-align: center;
        font-size: 32px;
        color: #fff;
    }
    .noticeDetailPop-name{
        height: 80px;
        line-height: 80px;
        position: relative;
        border-bottom: 0.5px solid #666;
        padding: 0 24px;
        font-size: 32px;
        color: #333;
        margin-left: 24px;
        width: calc(100% - 48px);
    }
    .noticeDetailPop-content{
        max-height: 580px;
        min-height: 400px;
        overflow-y: auto;
        font-size: 28px;
        color: #000;
        padding: 24px;
    }
}
</style>
